import React, { useEffect, useRef, useMemo, useState } from "react";
import mapboxgl from "mapbox-gl";
import MapboxGL from "mapbox-gl";

import "mapbox-gl/dist/mapbox-gl.css";
import {
  FullscreenControl,
  GeolocateControl,
  NavigationControl,
} from "mapbox-gl";
import { useSelector } from "react-redux";
// import { useDispatch} from "react-redux";
import {
  getL1SheetProperty,
  getL2SheetProperty,
  setLevel2Properties,
} from "../../../features/reduxworkbook/WorkbookSlice";
import { cityArray, stateArray } from "./citynStateArray";
import { createMaxMinObject } from "../Utils/DataTransform/transformData2";
import { mapTransformData } from "../Utils/mapTransFormData";
import { getColourSchemeByID } from "../../../Colors/ColorPalettes";
import { useGetFiltersOptionsMutation } from "../../../features/reduxworkbook/dataApiSlice";
import CellFormatter from "../Utils/CellFormatter";

const AreaMap = ({ Data, valueKeys = [], groupByKeys, Sheetid, reduxKey }) => {
  const availableAreas = [];

  const measureKey = valueKeys[0]?.responseKey;
  const formattedObjects = [];
  const areaColours = {};
  const mapContainerRef = useRef(null);
  // const dispatch = useDispatch();
  // const [uniqueValue, setUniqueValue] = useState([]);
  // console.log(areaColours);

  const droppedItems = useSelector((state) => {
    return getL2SheetProperty(state, Sheetid, "customization", reduxKey);
  });
  const dataSourceID = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "dataSourceID")
  );
  const customization = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "customization")
  );
  const [
    getFiltersOptions,
    { data: distinctFilterOptions, isError, error, isLoading, isSuccess },
  ] = useGetFiltersOptionsMutation();

  useEffect(() => {
    if (
      valueKeys.length === 0 &&
      groupByKeys.length &&
      !distinctFilterOptions
    ) {
      const firstItemOfGroupByKeys = groupByKeys[0];
      const filterBody = {
        databaseID: dataSourceID,
        columns: [
          {
            name: firstItemOfGroupByKeys.columnName,
            dataType: firstItemOfGroupByKeys.dataType,
          },
        ],
      };
      if (filterBody !== null) {
        // console.log(filterBody);
        getFiltersOptions({ filterBody, calledFrom: "areaMap" });
      }
    }
  }, [distinctFilterOptions, groupByKeys, valueKeys]);
  let {
    rows: areaMapping,
    conditionalFormatting,
    selectedAreaUnit,
  } = customization;
  // // console.log(areaMapping);

  const { mapTransformedData } = useMemo(() => {
    return mapTransformData(Data, areaMapping, groupByKeys);
  }, [Data, areaMapping, groupByKeys]);
  // // console.log(areaMapping);

  let maxMinData;
  if (valueKeys.length) {
    maxMinData = createMaxMinObject(Data[0], valueKeys);
    Data.forEach((item) => {
      const valKey = valueKeys[0].responseKey;
      const value = Number(item[valKey]);
      if (value > maxMinData[valKey].max) {
        maxMinData[valKey].max = value;
      }
      if (value < maxMinData[valKey].min) {
        maxMinData[valKey].min = value;
      }
    });
  }

  // // console.log(maxMinData);
  const textAlign = {
    globalAlignment: "center",
    rowTextAlign: "",
    valueTextAlign: "",
    isGlobalTextAlignmnet: true,
  };
  const colorSchemeid = customization.colorSchemeid || "echarts4Colors";
  const COLORS = getColourSchemeByID(colorSchemeid).colors;
  let result = null;
  // console.log(distinctFilterOptions);
  // console.log(COLORS);
  if (groupByKeys.length && distinctFilterOptions) {
    const firstItemOfGroupByKeys = groupByKeys[0];
    const options = distinctFilterOptions[firstItemOfGroupByKeys.columnName];

    result = Object.fromEntries(
      options.map((key, index) => [key, COLORS[index % COLORS.length]])
    );
  }
  // console.log(result);

  mapTransformedData.forEach((item) => {
    const displayValue = item[measureKey];
    const formattedObject = CellFormatter(
      measureKey,
      displayValue,
      conditionalFormatting,
      maxMinData,
      textAlign
    );
    // console.log(mapTransformedData);
    // // console.log(formattedObject);
    formattedObjects.push(formattedObject); // Store formatted object in the array
    const area = item[groupByKeys[0]?.responseKey];
    const areaColour = formattedObject.bgColor;
    areaColours[area] = areaColour; // Assign color to the state
  });
  const idForClickedValue = selectedAreaUnit;
  const handleClickedArea = (clickedArea) => {
    // console.log(clickedArea);
  };

  function classifyLocation(name) {
    if (stateArray.includes(name)) {
      return "State";
    } else if (cityArray.includes(name)) {
      return "City";
    } else {
      return "Unknown";
    }
  }

  const firstKey = result !== null ? Object.keys(result)[0] : null;
  if (firstKey) {
    selectedAreaUnit = classifyLocation(firstKey);
  }
  // console.log(selectedAreaUnit);
  useEffect(() => {
    mapboxgl.accessToken =
      "pk.eyJ1Ijoia2hhbmRhbmlzaCIsImEiOiJjbHVqYmJ0cmkwZGVxMnBwaHlrbWF6cG8xIn0.YNX48zrv4Gim-H2GmoZqPA"; // Replace with your Mapbox access token
    const map = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: "mapbox://styles/mapbox/light-v10",
      center: [78.9629, 23.5937], // Center of India
      zoom: 4,
    });
    // Ensure availableAreas is defined and has elements before calling forEach
    if (availableAreas && Array.isArray(availableAreas)) {
      availableAreas.forEach((City) => {
        const [longitude, latitude] = City.coordinates; // Get coordinates from the city data
        new MapboxGL.Marker()
          .setLngLat([longitude, latitude])
          .setPopup(new MapboxGL.Popup().setHTML(`<h3 >${City.name}</h3>`))
          .addTo(map);
      });
    }

    map.addControl(new FullscreenControl(), "top-left");
    map.addControl(
      new GeolocateControl({
        positionOptions: { enableHighAccuracy: true },
        trackUserLocation: true,
      })
    );
    map.addControl(new NavigationControl(), "top-left");

    map.on("load", () => {
      if (selectedAreaUnit === "City") {
        // console.log("Load the city data");
        fetch("/indian-cities.geojson")
          .then((response) => response.json())
          .then((geoData) => {
            if (valueKeys.length) {
              const { max, min } = maxMinData[measureKey];
              const radiusRange = { min: 10, max: 50 };
              geoData.features.forEach((feature) => {
                const cityName = feature.properties.name;
                // Assuming you want to assign color based on city name or some property
                feature.properties.fillColor =
                  areaColours[cityName] || "transparent";
                // console.log(cityName);

                const cityData = mapTransformedData.find(
                  (item) => item[groupByKeys[0]?.responseKey] === cityName
                );

                // const revenue = cityData?.SUM_revenue || min;
                const revenue = cityData?.[measureKey] || min;
                const normalizedValue = (revenue - min) / (max - min);
                const scaledRadius =
                  radiusRange.min +
                  normalizedValue * (radiusRange.max - radiusRange.min);

                map.addLayer({
                  id: `${cityName}-center-circle`,
                  type: "circle",
                  source: {
                    type: "geojson",
                    data: {
                      type: "FeatureCollection",
                      features: [
                        {
                          type: "Feature",
                          properties: {},
                        },
                      ],
                    },
                  },
                  paint: {
                    "circle-radius": scaledRadius,
                    "circle-color": areaColours[cityName] || "transparent",
                    "circle-opacity": 1,
                  },
                });
              });
            } else {
              geoData.features.forEach((feature) => {
                const cityName = feature.properties.name;
                // Assuming you want to assign color based on city name or some property
                feature.properties.fillColor =
                  result[cityName] || "transparent";
                // console.log(cityName);

                map.addLayer({
                  id: `${cityName}-center-circle`,
                  type: "circle",
                  source: {
                    type: "geojson",
                    data: {
                      type: "FeatureCollection",
                      features: [
                        {
                          type: "Feature",
                          properties: {},
                        },
                      ],
                    },
                  },
                  paint: {
                    "circle-color": areaColours[cityName] || "transparent",
                    "circle-opacity": 1,
                  },
                });
              });
            }

            map.addSource("cities", {
              type: "geojson",
              data: geoData,
            });

            map.addLayer({
              id: "cities-fill-layer",
              type: "fill",
              source: "cities",
              paint: {
                "fill-color": ["get", "fillColor"],
                // "fill-opacity": 0.5, // Adjust transparency of city area fill
              },
            });

            // Add popup functionality for cities
            const popup = new mapboxgl.Popup({
              closeButton: false,
              closeOnClick: false,
            });

            map.on("mousemove", "cities-fill-layer", (e) => {
              map.getCanvas().style.cursor = "pointer";
              const cityName = e.features[0].properties.name;
              const data = mapTransformedData.find(
                (item) => item[groupByKeys[0]?.responseKey] === cityName
              );
              // Format the data as a list of key-value pairs
              let dataContent = "No data available";
              if (data) {
                dataContent =
                  "<ul style='list-style-type: none; padding: 0; margin: 0;'>";
                for (const [key, value] of Object.entries(data)) {
                  dataContent += `
                    <li><strong>${key}:</strong> ${value}</li>
                  `;
                }
                dataContent += "</ul>";
              }
              // Display the formatted content in the popup
              popup
                .setLngLat(e.lngLat)
                .setHTML(
                  `
                  <div style=" padding: 5px; border-radius: 2px; ">
                    <strong>${cityName}</strong><br/>
                    <div style="text-align: center; margin-bottom: 5px;">
                    <div style="background-color: ${
                      areaColours[cityName] || "transparent"
                    }; 
                               border-radius: 50%; 
                               width: 20px; height: 20px; 
                               margin: 0 auto;">
                    </div>
                  </div>
                    <div style="border: 1px solid #ccc; padding: 8px; margin-top: 5px;">
                      ${dataContent}
                    </div>
                  </div>
                `
                )
                .addTo(map);
            });

            map.on("mouseleave", "cities-fill-layer", () => {
              map.getCanvas().style.cursor = "";
              popup.remove();
            });
          })
          .catch((error) =>
            console.error("Error fetching City GeoJSON:", error)
          );
      } else if (selectedAreaUnit === "State") {
        // console.log("Load the state data");
        fetch("./india_state_geo.json")
          .then((response) => response.json())
          .then((geoData) => {
            if (valueKeys.length) {
              const { max, min } = maxMinData[measureKey];
              const radiusRange = { min: 10, max: 50 }; // Min and max radius in pixels
              // console.log(geoData);

              geoData.features.forEach((feature) => {
                const stateName = feature.properties.NAME_1;
                feature.properties.fillColor =
                  areaColours[stateName] || "transparent";

                // Fetch the state's revenue data
                const stateData = mapTransformedData.find(
                  (item) => item[groupByKeys[0]?.responseKey] === stateName
                );

                // Default revenue if no data
                const revenue = stateData?.[measureKey] || min;

                // Normalize the revenue value to [0, 1]
                const normalizedValue = (revenue - min) / (max - min);

                // Scale the normalized value to the radius range
                const scaledRadius =
                  radiusRange.min +
                  normalizedValue * (radiusRange.max - radiusRange.min);

                // Add circle layer for state center
                map.addLayer({
                  id: `${stateName}-center-circle`,
                  type: "circle",
                  source: {
                    type: "geojson",
                    data: {
                      type: "FeatureCollection",
                      features: [
                        {
                          type: "Feature",
                          properties: {},
                        },
                      ],
                    },
                  },
                  paint: {
                    "circle-radius": scaledRadius, // Use dynamic radius
                    "circle-color": areaColours[stateName] || "transparent",
                    "circle-opacity": 1,
                  },
                });
              });
            } else {
              geoData.features.forEach((feature) => {
                const stateName = feature.properties.NAME_1;
                feature.properties.fillColor =
                  result[stateName] || "transparent";

                map.addLayer({
                  id: `${stateName}-center-circle`,
                  type: "circle",
                  source: {
                    type: "geojson",
                    data: {
                      type: "FeatureCollection",
                      features: [
                        {
                          type: "Feature",
                          properties: {},
                        },
                      ],
                    },
                  },
                  paint: {
                    "circle-color": areaColours[stateName] || "transparent",
                  },
                });
              });
            }

            map.addSource("states", {
              type: "geojson",
              data: geoData,
            });

            map.addLayer({
              id: "states-layer",
              type: "fill",
              source: "states",
              layout: {},
              paint: {
                "fill-color": ["get", "fillColor"],
              },
            });

            // Add popup functionality for states
            const popup = new mapboxgl.Popup({
              closeButton: false,
              closeOnClick: false,
            });

            map.on("mousemove", "states-layer", (e) => {
              map.getCanvas().style.cursor = "pointer";
              const stateName = e.features[0].properties.NAME_1;
              const data = mapTransformedData.find(
                (item) => item[groupByKeys[0]?.responseKey] === stateName
              );

              // Format the data as a list of key-value pairs
              let dataContent = "No data available";
              if (data) {
                dataContent =
                  "<ul style='list-style-type: none; padding: 0; margin: 0;'>";
                for (const [key, value] of Object.entries(data)) {
                  dataContent += `
                    <li><strong>${key}:</strong> ${value}</li>
                  `;
                }
                dataContent += "</ul>";
              }
              // console.log(areaColours);
              // console.log(data);
              const propertiesHTML =
                data &&
                Object.entries(data)
                  .map(
                    ([key, value]) =>
                      `<div><strong>${key}:</strong> ${value}</div>`
                  )
                  .join("");
              popup
                .setLngLat(e.lngLat)
                .setHTML(
                  `<div class="custom-tooltip">
                    <div class="custom-tooltip-content">
                      ${propertiesHTML}
                    </div>
                  </div>
                  `
                )
                .addTo(map);
            });
            map.on("mouseleave", "states-layer", () => {
              map.getCanvas().style.cursor = "";
              popup.remove();
            });

            droppedItems.forEach((item) => {
              const { latitude, longitude } = item;
              new mapboxgl.Marker().setLngLat([longitude, latitude]).addTo(map);
            });
          })
          .catch((error) => console.error("Error fetching GeoJSON:", error));
      } else {
        // console.log("Do not load any data");
      }
      // Add click handler
      if (idForClickedValue === "State") {
        map.on("click", "states-layer", (e) => {
          const clickedFeature = e.features[0];
          const stateName = clickedFeature.properties.NAME_1;

          if (areaColours[stateName]) {
            // console.log(stateName);
            handleClickedArea(stateName);
            // You can now use stateName as your clickedValue
          } else {
            // console.log("Area not in areaColours:", stateName);
          }
        });
      }
      if (idForClickedValue === "City") {
        map.on("click", "cities-fill-layer", (e) => {
          const cityName = e.features[0].properties.name;
          // console.log(cityName);

          if (areaColours[cityName]) {
            // console.log(cityName);
            handleClickedArea(cityName);
            // You can now use cityName as your clickedValue
          } else {
            // console.log("Area not in areaColours:", cityName);
          }
        });
      }
    });

    // Add Markers from Data
    if (Array.isArray(Data)) {
      Data.forEach((item) => {
        // Check if Coordinates is defined and is a string
        if (item.Coordinates && typeof item.Coordinates === "string") {
          const coordinates = item.Coordinates.split(",").map(Number);
          if (coordinates.length === 2) {
            const [latitude, longitude] = coordinates;
            new mapboxgl.Marker()
              .setLngLat([longitude, latitude]) // Note: Mapbox uses [longitude, latitude]
              .setPopup(
                new mapboxgl.Popup().setHTML(
                  `<h3>Location</h3><p>${item.Coordinates}</p>`
                )
              ) // Optional popup
              .addTo(map);
          }
        } else {
          console.warn("Invalid or missing Coordinates for item:", item);
        }
      });
    }

    return () => map.remove();
  }, [mapTransformedData, valueKeys, formattedObjects, availableAreas]);
  // // console.log(areaColours);
  return (
    <div className="h-full w-full ">
      <div ref={mapContainerRef} className="h-full w-full" />
    </div>
  );
};

export default AreaMap;
